/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import { numberToPrettyString } from '@cian/utils';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { trackBannerClick, trackBannerShow } from './tracking';

import * as styles from './index.css';

export interface IContractBannerProps {
  context: IAdFoxBannerContext;
  monthlyPayment?: number;
}

export class ContractBanner extends React.PureComponent<IContractBannerProps, {}> {
  public componentDidMount() {
    trackBannerShow();
  }

  public render() {
    const { context } = this.props;

    return (
      <a target="_blank" onClick={trackBannerClick} href={context.reference} className={styles['container']}>
        {context.label && <div className={styles['advertising']}>{context.label}</div>}
        <div {...mergeStyles([styles['image'], { backgroundImage: `url(${context.imageURL})` }])} />
        {this.props.monthlyPayment && (
          <div>
            <p className={styles['text-wrapper']}>
              <span className={styles['text']}>
                <b>{context.boldText}</b>
                {` от ${numberToPrettyString(this.props.monthlyPayment)} \u20bd / мес`}
              </span>
            </p>
            <p className={styles['text-wrapper']}>
              <span>
                <b>{context.referenceText}</b>
              </span>
            </p>
          </div>
        )}
      </a>
    );
  }
}
